/**************************************************
 * Nombre:       Valores_Reservas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useEffect, useState} from "react";
import {obtenerNumNoches} from "../../Modulo_Motor_Reservas/Funciones/obtenerNumNoches";
import {obtenerDiasPromocion} from "../../CodNegocio/obtenerDiasPromocion";
import {obtenerValorTotalSaldo, totalArr} from "../../CodNegocio/obtenerValorTotalSaldo";

const Valores_Reservas = ({props}) => {
    const [valAdicionales, setValAdicionales] = useState(0)
    const [valDescuentos, setValDescuentos] = useState(0)
    const [reserva, setReserva] = useState({})
    const [numDiasPromo, setNumDiasPromo] = useState(0)
    const [valorReserva, setValorReserva] = useState(0)
    const [valAbonos, setValAbonos] = useState(0)
    const [numNoches, setNumNoches] = useState(0)
    const [valServicio, setValServicio] = useState(0)

    const Linea = ({titulo, valor, descuento = false}) => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}} sx={{px: 1}}>

                <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{mt: -1}}>
                    <Typography>{titulo}</Typography>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-end', mt: -1}}>
                    <Typography
                        sx={{fontWeight: 600}}>{descuento ? `-${formatoMoneda(valor)}` : `${formatoMoneda(valor)}`}</Typography>
                </Grid>


            </Grid>
        )
    }


    useEffect(() => {

        let adicionales = props.props.getValues('adicionales')
        let descuentos = props.props.getValues('descuentos')
        let abonos = props.props.getValues('abonos')

        if (adicionales) {
            let totAdi = totalArr(adicionales)
            setValAdicionales(totAdi)
        }

        if (descuentos) {
            let totDes = totalArr(descuentos)
            setValDescuentos(totDes)
        }

        if (abonos) {
            let totAbo = totalArr(abonos)
            setValAbonos(totAbo)
        }

        let reserva = props.props.getValues()
        setReserva(reserva)

        let numNoches = obtenerNumNoches({
            fechaCheckIn: reserva.fechaCheckIn,
            fechaCheckOut: reserva.fechaCheckOut
        })
        setNumNoches(numNoches)

        let diasPromo = obtenerDiasPromocion({
            numNoches: numNoches,
            fechaCheckIn: reserva.fechaCheckIn,
            diasPromo: reserva.diasPromo
        })
        setNumDiasPromo(diasPromo)

        let valReserva = numNoches * reserva.tarifa
        setValorReserva(valReserva)


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Linea titulo={`Num de Noches ( ${numNoches} )`}
                   valor={valorReserva}/>

            <Linea titulo={`Descuento Dias Promo (${numDiasPromo})`}
                   valor={valorReserva - (numDiasPromo * reserva.valorPromo)} descuento/>

            <Linea titulo={'Total Adicionales'} valor={valAdicionales}/>

            <Linea titulo={'Otros Descuentos'} valor={valDescuentos} descuento={true}/>

            <Linea titulo={'Total Abonos'} valor={valAbonos}/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{borderTop: 1, pt: 3}}>
                <Linea titulo={'Total Servicio'}
                       valor={valorReserva - (valorReserva - (numDiasPromo * reserva.valorPromo)) + valAdicionales - valDescuentos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{borderTop: 1, pt: 3}}>
                <Linea titulo={'Saldo'} valor={obtenerValorTotalSaldo(reserva)}/>
            </Grid>


        </Grid>
    )

}
export default Valores_Reservas